import React from 'react';
import { Checkbox, type CheckboxProps, FormControlLabel } from '@material-ui/core';
import { Icon, Tooltip } from '@popmenu/common-ui';
import { Help, CheckCircle, Circle } from '@popmenu/web-icons';

import Grid from '../../../shared/Grid';

export interface CheckBoxProps extends Omit<Partial<CheckboxProps>, 'title'> {
  'data-tour-id'?: string | null;
  className?: string;
  field: string;
  radio?: boolean;
  // @deprecated Equivalent to radio
  radioCheck?: boolean;
  rootClassName?: string;
  title?: MaybeFormattedMessage | null;
  titleTooltip?: MaybeFormattedMessage | null;
  value?: boolean | number | string;
}

const CheckBox = ({
  'data-tour-id': dataTourId = null,
  checked = false,
  className,
  color = 'primary',
  disabled = false,
  field,
  onChange,
  radio = false,
  radioCheck = false,
  rootClassName,
  title = null,
  titleTooltip = null,
  value = true,
  ...inputProps
}: CheckBoxProps) => {
  const name = typeof field === 'string' ? field : field[0];
  let label;
  if (titleTooltip) {
    label = (
      <Grid container inline spacing={0} style={{ whiteSpace: 'normal' }}>
        <Grid item>
          {title}
        </Grid>
        <Grid
          item
          onClick={(e) => {
            // Called to prevent click on tooltip icon from toggling checkbox
            e.preventDefault();
            e.stopPropagation();
            return false;
          }}
        >
          <Tooltip title={titleTooltip}>
            <div>
              <Icon aria-hidden icon={Help} style={{ marginLeft: '8px', position: 'relative', top: '4px' }} />
            </div>
          </Tooltip>
        </Grid>
      </Grid>
    );
  } else {
    label = title;
  }

  let checkedIcon;
  let icon;
  let indeterminateIcon;

  if (radio || radioCheck) {
    checkedIcon = <Icon aria-label="Checked" icon={CheckCircle} />;
    icon = <Icon aria-label="Unchecked" icon={Circle} />;
    indeterminateIcon = <Icon aria-label="Indeterminate" icon={Circle} />;
  }

  return (
    <FormControlLabel
      className={className}
      control={(
        <Checkbox
          color={color}
          autoComplete="off"
          checked={checked}
          checkedIcon={checkedIcon}
          icon={icon}
          indeterminateIcon={indeterminateIcon}
          inputProps={{
            // @ts-expect-error Not explicitly supported by Checkbox but should work
            'data-tour-id': dataTourId,
          }}
          name={name}
          onChange={onChange}
          classes={{
            root: rootClassName,
          }}
          value={String(value)}
          {...inputProps}
        />
      )}
      disabled={disabled}
      label={label}
    />
  );
};

export default CheckBox;
